site.cookie = {
	init: function () {
		console.log(Cookies.get('moyaPPCookie'));
		if(Cookies.get('moyaPPCookie') === undefined) {
			console.log('its undefined');
			var d = $('#cookie');
			d.show();
			d.find('.cookie__accept').bind('click',function() {
				Cookies.set('moyaPPCookie', 1, {expires: 20*365, path: '/'});
				d.hide();
			});
		}
	}
};

site.inits.push('site.cookie.init()');